import { DeleteAutomationDialog } from "@/action-dialog/dialogs/DeleteAutomationDialog";
import { createCallable } from "react-call";
import { useMutationFlow, type MutationFn } from "react-call/mutation-flow";

const UNMOUNTING_DELAY_MS = 200;

export type DeleteAutomationCallableProps = {
  name: string;
  mutationFn?: MutationFn<boolean, void>;
};

export const DeleteAutomationCallable = createCallable<
  DeleteAutomationCallableProps,
  boolean
>(({ call, name, mutationFn }) => {
  const submit = useMutationFlow(call, mutationFn);
  const pending = submit.pending;

  return (
    <DeleteAutomationDialog
      name={name}
      open
      isWorking={pending}
      onOpenChange={(open) => {
        if (!open && !pending) {
          call.end(false);
        }
      }}
      onConfirm={() => submit().orEnd(true)}
    />
  );
}, UNMOUNTING_DELAY_MS);

DeleteAutomationCallable.displayName = "DeleteAutomationCallable";
